<template>
  <div class="chatSetting">
    <!-- <div class="module-item-style">
      <div class="module-item-title">
        <div>pc网页访客会话框自定义设置</div>
      </div>
    </div> -->
    <div class="module-item-style">
	  <div class="module-item-title">pc网页访客会话框广告轮播图自定义设置</div>
      <div class="chatSetting-tips">最多可添加 10 张图片, 图片建议最大宽高：194 * 292</div>
      <div class="chatSetting-content">
        <ul class="adPicItemwrap">
          <draggable class="draggableCss" v-model="addPicList" @start="drag=true" @end="picOnEnd">
            <li class="picItem" v-for="(item, i) in addPicList" :key="'adPic' + i">
              <img :src="item.adPicture" alt />
              <div class="handlerModel">
                <div class="handlerItem" @click="editAdPic(item)">
                  <i class="el-icon-edit-outline"></i> 编辑
                </div>
                <div class="handlerItem" @click="delAdPic(item)">
                  <i class="el-icon-delete"></i> 删除
                </div>
              </div>
            </li>
          </draggable>
          <li class="picItem" @click="addNewAdPic" v-if="addPicList.length < 10">
            <i class="addIcon el-icon-plus"></i>
          </li>
        </ul>
      </div>
    </div>

    <div class="module-item-style">
	  <div class="module-item-title">pc网页访客会话框小工具自定义设置</div>
      <div class="chatSetting-tips">最多可添加 4 个小工具，图片建议宽高： 32 * 32；工具名称建议不超过 5 个字</div>
      <div class="chatSetting-content">
        <ul class="adToolItemwrap">
          <draggable class="draggableCss" v-model="toolList" @start="drag=true" @end="toolOnEnd">
            <li class="tollItem" v-for="(item, i) in toolList" :key="'tool' + i">
              <img :src="item.icon" alt />
              <div class="iconName">{{item.iconDesc}}</div>
              <div class="handlerModel">
                <div class="handlerItem" @click="editTool(item)">
                  <i class="el-icon-edit-outline"></i> 编辑
                </div>
                <div class="handlerItem" @click="delTool(item)">
                  <i class="el-icon-delete"></i> 删除
                </div>
              </div>
            </li>
          </draggable>
          <li class="tollItem" @click="addNewTool" v-if="toolList.length < 4">
            <i class="addIcon el-icon-plus"></i>
          </li>
        </ul>
      </div>
    </div>
	<div class="module-item-style">
		<div class="module-item-title">访客会话框标题设置</div>
		<div class="module-item-tips">访客会话界面，顶部标题显示可自定义设置，默认是"微聊客服"</div>
		<div class="chat-title-setting">
			<el-input @blur="saveChange('visitor_chat_page_title',chatTitle)" v-model="chatTitle" placeholder="请输入标题"></el-input>
		</div>
	</div>
	<div class="module-item-style">
		<div class="module-item-title">PC端、移动端访客会话框顶部颜色设置</div>
		<div class="module-item-tips">PC端、移动端访客会话界面，顶部颜色可自定义设置，默认是#428efe</div>
		<div class="chat-color-setting">
			<el-color-picker v-model="chatColor" @change="saveChange('dialog_box_color',chatColor)"></el-color-picker>
		</div>
	</div>
	<div class="module-item-style">
		<div class="module-item-title online-chat-title">
		  <div>
		    PC端访客会话框给您回电框设置
		  </div>
		  <div class="online-chat-switch-btn">
		    <el-switch
		        v-model="callbackBtn"
		        @change="saveChange('is_open_call_back',callbackBtn)"
		        active-color="#68B974">
		    </el-switch>
		  </div>
		</div>
		<div class="module-item-tips">默认开启，关闭后，PC端将不再显示给您回电框</div>
		
	</div>
	<div class="module-item-style">
		<div class="module-item-title online-chat-title">
		  <div>
		    移动端访客会话框快捷引导语设置
		  </div>
		  <div class="online-chat-switch-btn">
		    <el-switch
		        v-model="quickGuideBtn"
		        @change="saveChange('is_open_quick_guide',quickGuideBtn)"
		        active-color="#68B974">
		    </el-switch>
		  </div>
		</div>
		<div class="module-item-tips">开启后，移动端访客会话输入框上面会显示快捷引导语，用户可以进行点击</div>
		<div class="chat-quickGuide-wrap" v-if="quickGuideBtn==true || quickGuideBtn=='true'">
			<div class="tag-add-btn">
			    <div class="wl-btn" @click="addGuide()"><i class="el-icon-plus"></i>添加标签</div>
			</div>
			<div class="table-box">
			    <el-table
			            :data="tableData"
			            stripe
			            :header-cell-style="{background:'#f2f2f2'}"
			            style="border: 1px solid #ebeef5;">
			        <el-table-column label="快捷引导标签名称" min-width="120px" class="level">
			          <template slot-scope="scope">
			    		  <span>{{scope.row.guideTag}}</span>
			          </template>
			        </el-table-column>
			    	<el-table-column label="快捷引导内容链接" align="center">
			    	  <template slot-scope="scope">
			    		<span>{{scope.row.content || '--'}}</span>
			    	  </template>
			    	</el-table-column>
				
			        <el-table-column label="操作" width="180px" align="center">
			            <template slot-scope="scope">
							<span v-if="scope.row.type==1">系统功能，无法进行操作</span>
			    			<button v-else class="tb-btn" :class="'tb-btn-'+handler.type"
			    			        v-for="(handler, index) in tableHandler"
			    			        :key="'handler'+ index"
			    			        @click="handleButton(handler.methods, scope.row)">{{handler.label}}
			    			</button>
							
			            </template>
			        </el-table-column>
					<el-table-column label="显示关闭" width="80px">
					  <template slot-scope="scope">
						  <el-switch
						      v-model="scope.row.isActive==1?true:false" 
							  @change="editGuideActive(scope.row.id,scope.row.isActive)"
						      active-color="#68B974">
						  </el-switch>
					  </template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
    <!-- 广告编辑-增加弹出层 -->
    <el-dialog
      :title="adFormDialogTitle"
      :visible.sync="adPicDialogVisible"
      width="30%"
      class="adFormDialog"
      :before-close="handleClose"
    >
      <el-form ref="adPicForm" :model="adPicForm" :rules="rules" label-width="80px">
        <el-form-item label="广告图片" prop="adPicture">
          <div class="adPicItem">
            <el-input class="picInput" v-model="adPicForm.adPicture" placeholder="粘贴图片地址或上传图片"></el-input>
            <span class="choosePic" @click="choosePic">选择图片</span>
          </div>
          <input type="file" ref="chooseAdPic" @change="uploadAdImage" v-show="false" />
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="adPicForm.adPictureLink"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveAdPic('adPicForm')">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 小工具增加-编辑 弹出层 -->
    <el-dialog
      :title="toolFormDialogTitle"
      :visible.sync="toolDialogVisible"
      width="30%"
      class="adFormDialog"
      :before-close="handleToolClose"
    >
      <el-form ref="adToolForm" :model="adToolForm" :rules="toolRules" label-width="80px">
        <el-form-item label="图标" prop="icon">
          <div class="adPicItem">
            <el-input class="picInput" v-model="adToolForm.icon" placeholder="粘贴图片地址或上传图片"></el-input>
            <span class="choosePic" @click="chooseToolPic">选择图片</span>
          </div>
          <input type="file" ref="chooseToolPic" @change="uploadToolImage" v-show="false" />
        </el-form-item>
        <el-form-item label="名称" prop="iconDesc">
          <el-input v-model="adToolForm.iconDesc" placeholder="建议输入5个字以内"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="adToolForm.link"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleToolClose">取 消</el-button>
        <el-button type="primary" @click="saveSmallTool('adToolForm')">保 存</el-button>
      </span>
    </el-dialog>
	<!-- 快捷引导语增加-编辑 弹出层 -->
	<el-dialog
	        :title="guideDialogTitle"
	        width="450px"
	        class="guide-dialog"
	        :visible.sync="dialogFormVisible">
	    <div class="guide-content-container">
	        <div class="guide-input-box">
	            <div class="guide-input-label"><span>*</span>标签名称：</div>
	            <div>
	                <el-input v-model="guideForm.guideTag" placeholder="请输入标签名称" maxlength="8" show-word-limit></el-input>
	            </div>
	        </div>
			<div class="guide-input-box">
			    <div class="guide-input-label"><span>*</span>链接地址：</div>
			    <div>
			        <el-input v-model="guideForm.content" placeholder="请输入链接地址"></el-input>
			    </div>
			</div>
	    </div>
	    <div slot="footer" class="dialog-footer">
	        <el-button @click="dialogFormVisible = false">取 消</el-button>
	        <el-button type="primary" @click="submitData">确 定</el-button>
	    </div>
	</el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "chatSettng",
  components: {
    draggable
  },
  data() {
    return {
      adPicDialogVisible: false,
      accept: "image/gif, image/jpeg, image/png, image/jpg",
      adPicForm: {
        adPicture: "",
        adPictureLink: ""
      },
      addPicList: [],
      adFormDialogTitle: "",
      adPicHandlerType: "",
      rules: {
        adPicture: [
          { required: true, message: "广告图片内容不能为空", trigger: "blur" }
        ]
      },

      toolDialogVisible: false,
      adToolForm: {
        icon: "",
        iconDesc: "",
        link: ""
      },
      toolFormDialogTitle: "",
      toolPicHandlerType: "",
      toolList: [],
      toolRules: {
        icon: [
          { required: true, message: "图片内容不能为空", trigger: "blur" }
        ],
        iconDesc: [{ required: true, message: "名称不能为空", trigger: "blur" }]
      },
      picSort:[],
      toolSort:[],
	  chatTitle:"微聊客服",
	  chatColor:"#428efe",
	  quickGuideBtn:false,
	  callbackBtn:false,
	  tableHandler: [
	      {label: "编辑", type: 'edit', methods: 'editMethods'},
	      {label: "删除", type: 'del', methods: 'delMethods'},
	  ],
	  tableData: [],
	  dialogType:'add',
	  guideForm: {
	      guideTag: '',
	      content: ''
	  },
	  guideId:'',
	  guideDialogTitle: '添加标签',
	  dialogFormVisible: false
    };
  },
  created() {
    this.getVisitorAdPicList();
    this.getVisitorToolList();
	this.getBaseConfig();
	this.getGuideData();
  },
  mounted() {},
  methods: {
    /**
     * 获取轮播图
     */
    getVisitorAdPicList() {
      this.$http
        .visitorAdPicListAPI()
        .then(res => {
          if (res.status == 1) {
            this.picSort = []
            this.addPicList = res.data;
            this.addPicList.map((item) => {
                let newItem = {}
                newItem.id = item.id
                newItem.sort = item.sort || 0
                this.picSort.push(newItem)
            })
          }
          console.log("getAdPicList-res=", res);
        })
        .catch(err => {
          console.log("getAdPicList-error=", err);
        });
    },
    /**
     * 获取自定义小工具
     */
    getVisitorToolList() {
      this.$http
        .visitorToolListAPI()
        .then(res => {
          if (res.status == 1) {
            this.toolSort = []
            this.toolList = res.data;
            this.toolList.map((item) => {
                let newItem = {}
                newItem.id = item.id
                newItem.sort = item.sort || 0
                this.toolSort.push(newItem)
            })
          }
          console.log("getToolList-res=", res);
        })
        .catch(err => {
          console.log("getToolList-error=", err);
        });
    },
    /**
     * 上传广告图
     */
    addNewAdPic() {
      this.adFormDialogTitle = "增加广告图片";
      this.adPicHandlerType = "add";
      this.adPicDialogVisible = true;
      this.adPicForm = {
        adPicture: "",
        adPictureLink: ""
      };
    },
    // 选择图片
    choosePic() {
      this.$refs.chooseAdPic.click();
    },
    uploadAdImage(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      if (this.accept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message:
            "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (size > 5242880) {
        this.$message({
          showClose: true,
          message: "请选择5M以内的图片！",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http.uploadImageAPI(formdata).then(res => {
        if (res.status == 1) {
          this.adPicForm.adPicture = res.data;
        }
      });
    },
    // 取消或关闭弹出层
    handleClose(formName) {
      this.adPicForm = {
        adPicture: "",
        adPictureLink: ""
      };
      this.$refs['adPicForm'].resetFields();
      this.adPicDialogVisible = false;
    },
    // 删除广告图片
    delAdPic(item) {
      this.$alert("你正在进行删除操作，删除后将不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action === "confirm") {
            this.$http
              .visitorAdPicDelAPI({
                adPictureId: item.id
              })
              .then(res => {
                if (res.status == 1) {
                  this.getVisitorAdPicList();
                  this.$message({
                    type: "success",
                    message: `操作成功`
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: `操作失败`
                  });
                }
              });
          }
        }
      });
    },
    // 编辑图片
    editAdPic(item) {
      this.adFormDialogTitle = "编辑广告图片";
      this.adPicHandlerType = "edit";
      this.adPicDialogVisible = true;
      this.adPicForm = {
        adPictureId: item.id,
        adPicture: item.adPicture,
        adPictureLink: item.link
      };
    },
    saveAdPic(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.adPicHandlerType === "add") {
            this.$http.visitorAdPicAddAPI(this.adPicForm).then(res => {
              if (res.status == 1) {
                this.getVisitorAdPicList();
                this.$refs.chooseAdPic.value = "";
                this.$message.success(res.msg);
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          } else if (this.adPicHandlerType === "edit") {
            this.$http.visitorAdPicEditAPI(this.adPicForm).then(res => {
              if (res.status == 1) {
                this.getVisitorAdPicList();
                this.$refs.chooseAdPic.value = "";
                this.$message.success(res.msg);
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 排序
    picOnEnd(e) {
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;
      if (oldIndex > newIndex) {
          // 向上拖
          this.picSort.splice(newIndex, 0, this.picSort[oldIndex]);
          this.picSort.splice(oldIndex + 1, 1)
      } else {
          // 向下拖
          this.picSort.splice(newIndex + 1, 0, this.picSort[oldIndex]);
          this.picSort.splice(oldIndex, 1)
      }
      this.picSort.map((item, i) => {
          item.sort = i + 1
      })
      this.$http.visitorAdPicSortAPI({
          list: this.picSort
      }).then( res => {
          if(res.status == 1) {
               this.getVisitorAdPicList();
               this.$message.success('排序成功')
          } else {
               this.$message.error('排序失败')
          }
      }).catch(() => {
           this.$message.error('排序失败')
      })
    },

    /**
     * 自定义工具相关  👇
     */

    /**
     *添加小工具
     */
    addNewTool() {
      this.toolFormDialogTitle = "增加广告图片";
      this.toolPicHandlerType = "add";
      this.toolDialogVisible = true;
      this.adToolForm = {
        icon: "",
        iconDesc: "",
        link: ""
      };
    },
    // 选择图片
    chooseToolPic() {
      this.$refs.chooseToolPic.click();
    },
    uploadToolImage(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      if (this.accept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message:
            "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (size > 5242880) {
        this.$message({
          showClose: true,
          message: "请选择5M以内的图片！",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http.uploadImageAPI(formdata).then(res => {
        if (res.status == 1) {
          this.adToolForm.icon = res.data;
        }
      });
    },
    // 取消或关闭弹出层
    handleToolClose() {
      this.adToolForm = {
        icon: "",
        iconDesc: "",
        link: ""
      }
      this.$refs['adToolForm'].resetFields();
        this.toolDialogVisible = false
    },

    // 删除自定义小工具
    delTool(item) {
      this.$alert("你正在进行删除操作，删除后将不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action === "confirm") {
            this.$http
              .visitorToolDelAPI({
                iconLinkId: item.id
              })
              .then(res => {
                if (res.status == 1) {
                  this.getVisitorToolList();
                  this.$message({
                    type: "success",
                    message: `操作成功`
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: `操作失败`
                  });
                }
              });
          }
        }
      });
    },
    // 编辑自定义小工具
    editTool(item) {
      this.toolFormDialogTitle = "编辑广告图片";
      this.toolPicHandlerType = "edit";
      this.toolDialogVisible = true;
      this.adToolForm = {
        iconLinkId: item.id,
        icon: item.icon,
        iconDesc: item.iconDesc,
        link: item.link
      };
    },

    saveSmallTool(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.toolPicHandlerType === "add") {
            this.$http.visitorToolAddAPI(this.adToolForm).then(res => {
              if (res.status == 1) {
                this.getVisitorToolList();
                this.$refs.chooseToolPic.value = "";
                this.$message.success(res.msg);
                this.handleToolClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          } else if (this.toolPicHandlerType === "edit") {
            this.$http.visitorToolEditAPI(this.adToolForm).then(res => {
              if (res.status == 1) {
                this.getVisitorToolList();
                this.$refs.chooseToolPic.value = "";
                this.$message.success(res.msg);
                this.handleToolClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 排序
    toolOnEnd(e) {
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;
      if (oldIndex > newIndex) {
          // 向上拖
          this.toolSort.splice(newIndex, 0, this.toolSort[oldIndex]);
          this.toolSort.splice(oldIndex + 1, 1)
      } else {
          // 向下拖
          this.toolSort.splice(newIndex + 1, 0, this.toolSort[oldIndex]);
          this.toolSort.splice(oldIndex, 1)
      }
      this.toolSort.map((item, i) => {
          item.sort = i + 1
      })
      this.$http.visitorToolSortAPI({
          list: this.toolSort
      }).then( res => {
          if(res.status == 1) {
               this.getVisitorToolList();
               this.$message.success('排序成功')
          } else {
               this.$message.error('排序失败')
          }
      }).catch(() => {
           this.$message.error('排序失败')
      })
    },
	/**
	 * Author:wuzhiying
	 * createTime :2020.04.15 11:35
	 */
	/**
	 * 保存修改
	 */
	saveChange(name,value){
	  let postValue ;
	  if(name == 'visitor_chat_page_title' && value == ''){
	    this.$message({
	      message: '标题不能为空',
	      type: 'error',
	    })
	    return
	  }
	  if(name == 'dialog_box_color' && !value){
	    this.$message({
	      message: '请选择颜色',
	      type: 'error',
	    })
	    return
	  }
	  postValue = value  
	  if(name == 'is_open_quick_guide' || name == 'is_open_call_back'){
	    if(value == 'true' || value == true){
	      postValue = 1
	    }else if (value == 'false' || value == false) {
	      postValue = 0
	    }
	  }
	
	  this.$http.saveConfigAPI({
	    name,
	    value:postValue
	  }).then( res => {
	    if(res.status == 1){
	      this.$message({
	        message: res.msg,
	        type: 'success',
	      })
	      this.getBaseConfig()
	    }else {
	      this.$message({
	        message: res.msg,
	        type: 'error',
	      })
	    }
	  })
	},
	getBaseConfig(){
	  this.$http.getConfigAPI().then( res => {
		console.log(res)
		if(res.status == 1){
			res.data.is_open_quick_guide==1?this.quickGuideBtn = true : "",
			res.data.is_open_call_back==1?this.callbackBtn = true : ""
			this.chatTitle = res.data.visitor_chat_page_title
			this.chatColor = res.data.dialog_box_color
		}
	  })
	
	  // this.$http.getacceptanceMsgAPI().then(res => {
	  //   if(res.status == 1){
	  //         this.acceptance_msg = res.data.configValue
	  //   }
	  // })
	},
	handleButton(methods, row) {
	    if (methods == "delMethods") {
	        this.$confirm('将要进行删除操作, 是否继续?', '提示', {
	            confirmButtonText: '确定',
	            cancelButtonText: '取消',
	            type: 'warning'
	        }).then(() => {
	            this.$http.delGuideAPI({
	                guideId: row.id
	            }).then(res => {
	                if (res.status == 1) {
	                    this.getGuideData()
	                    this.$message({
	                        message: res.msg,
	                        type: 'success',
	                    })
	                } else {
	                    this.$message({
	                        message: res.msg,
	                        type: 'error',
	                    })
	                }
	            })
	        }).catch(() => {
	
	        });
	    } else {
	        this.editGuide(row)
	    }
	
	},
	getGuideData() {
	    this.$http.getGuideListAPI({}).then(res => {
			console.log(res)
	        if (res.status == 1) {
				this.tableData = res.data;
	        }
	    })
	},
	editGuideActive(guideId,isActive){
		this.$http.editGuideActiveAPI({
			guideId:guideId,
			isActive:isActive==1?0:1
		}).then(res => {
			console.log(res)
		    if (res.status == 1) {
				this.getGuideData();
		    }
		})
	},
	addGuide() {
	    this.dialogType = 'add'
	    this.guideDialogTitle = '添加标签'
	    this.dialogFormVisible = true
	
	},
	editGuide(item) {
	    this.guideForm = {
	        guideTag: item.guideTag,
	        content: item.content
	    }
	    this.guideId = item.id
	    this.dialogType = 'edit'
	    this.guideDialogTitle = '编辑标签'
	    this.dialogFormVisible = true
	},
	submitData() {
	    if (this.$utils.u_isEmpty(this.guideForm.guideTag)) {
	        this.$message({
	            message: '引导标签名不能为空',
	            type: 'error',
	        })
	        return false
	    }
		if (this.$utils.u_isEmpty(this.guideForm.content)) {
		    this.$message({
		        message: '引导链接地址不能为空',
		        type: 'error',
		    })
		    return false
		}
	    if(this.dialogType == 'add'){
	        this.$http.addGuideAPI(this.guideForm).then(res => {
	            if (res.status == 1) {
	                this.getGuideData()
	                this.dialogFormVisible = false
					this.guideForm = {
						guideTag:"",
						content:""
					}
	                this.$message({
	                    message: res.msg,
	                    type: 'success',
	                })
	            } else {
	                this.$message({
	                    message: res.msg,
	                    type: 'error',
	                })
	            }
	        })
	    }else if(this.dialogType == 'edit'){
	        let editPost = this.guideForm
	        editPost.guideId = this.guideId
	        this.$http.editGuideAPI(editPost).then(res => {
	            if (res.status == 1) {
	                this.getGuideData()
	                this.dialogFormVisible = false
					this.guideForm = {
						guideTag:"",
						content:""
					}
	                this.$message({
	                    message: res.msg,
	                    type: 'success',
	                })
	            } else {
	                this.$message({
	                    message: res.msg,
	                    type: 'error',
	                })
	            }
	        })
	    }
	},
  }
};
</script>

<style lang="scss">
.chatSetting {
  .chatSetting-tips {
    color: #999;
    font-size: 12px;
    padding: 12px 0 15px 0;
  }

  .chatSetting-content {
    .adPicItemwrap {
      display: flex;
      flex-wrap: wrap;
      .draggableCss {
        display: flex;
        flex-wrap: wrap;
      }
      .picItem {
        width: 148px;
        height: 148px;
        border-radius: 5px;
        border: 1px dashed #ddd;
        overflow: hidden;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        img {
          display: inline-block;
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
        .addIcon {
          font-size: 28px;
          color: #8c939d;
          font-weight: normal;
        }
        .handlerModel {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.6);
          display: none;
          align-items: center;
          justify-content: space-around;
          .handlerItem {
            color: #fff;
            font-size: 13px;
          }
        }
        &:hover {
          .handlerModel {
            display: flex;
          }
        }
      }
    }

    .adToolItemwrap {
      display: flex;
      flex-wrap: wrap;
      .draggableCss {
        display: flex;
        flex-wrap: wrap;
      }
      .tollItem {
        width: 100px;
        height: 100px;
        border-radius: 5px;
        border: 1px dashed #ddd;
        overflow: hidden;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        img {
          display: inline-block;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        .addIcon {
          font-size: 28px;
          color: #8c939d;
          font-weight: normal;
        }
        .iconName {
          width: 100%;
          padding: 0 6px;
          font-size: 13px;
          margin-top: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
          text-overflow: ellipsis;
          box-sizing: border-box;
        }
        .handlerModel {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.6);
          display: none;
          align-items: center;
          justify-content: space-around;
          .handlerItem {
            color: #fff;
            font-size: 13px;
          }
        }
        &:hover {
          .handlerModel {
            display: flex;
          }
        }
      }
    }
  }
  .adFormDialog {
    .adPicItem {
      display: flex;
      .picInput {
        flex: 1;
      }
      .choosePic {
        font-size: 13px;
        margin-left: 10px;
        background: #ddd;
        color: #666;
        cursor: pointer;
        text-align: center;
        padding: 0 10px;
        border-radius: 4px;
      }
    }
  }
  .chat-title-setting{
	display: flex;
	input,.el-input{
		width: 300px!important;
	}
	.wl-btn{
		margin-left: 15px;
	}
  }
  .online-chat-title{
	  display: flex;
	  flex-direction: row;
	  justify-content: space-between;
  }
  .guide-dialog {
  	  .guide-input-box {
  	      display: flex;
  	      align-items: center;
		  margin-bottom: 15px;
  	      .guide-input-label {
  	          font-size: 12px;
  	          color: #333;
  	  
  	          span {
  	              color: #FF4E00;
  	              padding-right: 5px;
  	              line-height: 40px;
  	          }
  	      }
  	  }
  }
  
}
.el-color-dropdown__btns .el-button--text{
	  display: none;
}
</style>